exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-home-components-Investment-___style__picture___3GguO{width:100%;border-radius:3px;margin-bottom:1em}.web-flows-home-components-Investment-___style__button___2X8K0>button{width:100%}.web-flows-home-components-Investment-___style__status_header___1IErz{margin-bottom:0;color:#95989a}", ""]);

// exports
exports.locals = {
	"picture": "web-flows-home-components-Investment-___style__picture___3GguO",
	"button": "web-flows-home-components-Investment-___style__button___2X8K0",
	"status_header": "web-flows-home-components-Investment-___style__status_header___1IErz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/home/components/Investment/style.css
// module id = 1352
// module chunks = 0